import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";
import Title from "../new-components/title/Title";
import HeaderInner from "../Components/HeaderInner";
import { ThemeContext } from "../context/ThemeContext";
import NewFooter from "../NewFooter";

const UAT_URL = "https://uat.mmihomedelivery.ae";
const PROD_URL = "https://mmihomedelivery.ae";

const MMI = () => {
  const iframeRef = useRef(null);
  const loaderRef = useRef(null);
  const headerWrapRef = useRef(null);
  const params = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);

  // const routeUuid = params.room_uuid;
  // const explicitUuid = searchParams.get("uuid");

  const location = useLocation();
  const rawPath = location.pathname;
  // const uuid = localStorage.getItem("room_uuid_before_redirect");
  const uuid = rawPath.split("/")[1];
  const env = searchParams.get("env");
  const baseUrl = PROD_URL;
  // const baseUrl =
  // process.env.REACT_APP_MMI_PROD_URL && process.env.REACT_APP_MMI_UAT_URL;

  const [loaded, setLoaded] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [sent, setSent] = useState(false);
  const [received, setReceived] = useState(false);
  const [receivedData, setReceivedData] = useState(null);
  const [error, setError] = useState(null);
  const [topOffset, setTopOffset] = useState(0);
  const [bottomOffset, setBottomOffset] = useState(0);

  // Measure header/footer heights to prevent overlay on the iframe
  useEffect(() => {
    const measure = () => {
      let top = 0;
      let bottom = 0;

      if (headerWrapRef.current) {
        const child = headerWrapRef.current.firstElementChild;
        if (child) {
          const rect = child.getBoundingClientRect();
          top = Math.ceil(rect.height);
        }
      }

      const footerEl = document.querySelector(".footer");
      if (footerEl) {
        const rect = footerEl.getBoundingClientRect();
        bottom = Math.ceil(rect.height);
      }

      setTopOffset(top);
      setBottomOffset(bottom);
    };

    const safeMeasure = () => {
      try {
        measure();
      } catch {}
    };

    safeMeasure();
    const onResize = () => safeMeasure();
    window.addEventListener("resize", onResize);
    const t = setTimeout(safeMeasure, 300);

    let roHeader;
    let roFooter;
    try {
      if ("ResizeObserver" in window) {
        roHeader = new ResizeObserver(safeMeasure);
        roFooter = new ResizeObserver(safeMeasure);
        if (headerWrapRef.current) roHeader.observe(headerWrapRef.current);
        const footerEl = document.querySelector(".footer");
        if (footerEl) roFooter.observe(footerEl);
      }
    } catch {}

    return () => {
      window.removeEventListener("resize", onResize);
      clearTimeout(t);
      if (roHeader) roHeader.disconnect();
      if (roFooter) roFooter.disconnect();
    };
  }, []);

  const handleIframeLoad = () => {
    setLoaded(true);
  };

  useEffect(() => {
    if (!loaded || !iframeRef.current || !uuid) return;
    const timeout = setTimeout(() => {
      try {
        iframeRef.current.contentWindow?.postMessage(
          { type: "UUID_SET", uuid },
          baseUrl
        );
        setSent(true);
      } catch (e) {
        setError("Failed to postMessage UUID");
      }
    }, 2000);
    return () => clearTimeout(timeout);
  }, [loaded, uuid, baseUrl]);

  useEffect(() => {
    const onMessage = async (event) => {
      console.log("Received message from iframe:", event);
      if (event.origin !== baseUrl) return;
      if (event.data?.type === "UUID_RECEIVED") {
        setReceived(true);
        setReceivedData(event.data.data);
      }
      // switch (event.data?.type) {
      //   case "PAYMENT_STATUS":
      //     if (event.data.status === "success") {
      //       // Option A: React Router
      //       navigate("/payment/success", { replace: true });
      //       // Option B: Hard redirect
      //       // window.location.replace("/payment/success");
      //     }
      //     if (event.data.status === "failed") {
      //       navigate("/payment/failed", { replace: true });
      //     }
      //     break;
      //   case "PAYMENT_DONE":
      //     // Shorthand: treat as success
      //     navigate("/payment/success", { replace: true });
      //     break;
      //   default:
      //     break;
      // }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [baseUrl, navigate]);

  // Hide loader when handshake completes or after a short fallback
  useEffect(() => {
    if (received) {
      setShowLoader(false);
      return;
    }
    if (loaded) {
      const t = setTimeout(() => setShowLoader(false), 2000);
      return () => clearTimeout(t);
    }
  }, [loaded, received]);

  return (
    <div
      style={{
        height: "85vh",
        position: "relative",
        overflow: "hidden",
        paddingTop: topOffset,
        paddingBottom: bottomOffset,
        boxSizing: "border-box",
      }}
    >
      {/* <div ref={headerWrapRef}>
        {theme ? (
          <HeaderInner headerName={"MMI"} theme={theme} />
        ) : (
          <HeaderInner headerName={"MMI"} theme={theme} />
        )}
      </div> */}
      {showLoader && (
        <div
          ref={loaderRef}
          style={{
            position: "absolute",
            top: topOffset,
            bottom: bottomOffset,
            left: 0,
            right: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f7f7f7",
            fontSize: 14,
            color: "#333",
            zIndex: 10,
          }}
        >
          <div role="status" aria-live="polite" aria-busy="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              width="32"
              height="32"
              aria-hidden="true"
            >
              <g>
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  opacity="0.25"
                />
                <path
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  opacity="0.75"
                />
                <animateTransform
                  attributeName="transform"
                  attributeType="XML"
                  type="rotate"
                  from="0 12 12"
                  to="360 12 12"
                  dur="1s"
                  repeatCount="indefinite"
                />
              </g>
            </svg>
            <span style={{ position: "absolute", left: -10000 }}>Loading</span>
          </div>
        </div>
      )}

      <iframe
        ref={iframeRef}
        loading="lazy"
        src={`${baseUrl}/?uuid=${encodeURIComponent(uuid || "")}`}
        width="100%"
        title="MMI Home Delivery"
        scrolling="auto"
        onLoad={handleIframeLoad}
        style={{
          border: "0",
          position: "absolute",
          top: topOffset,
          bottom: bottomOffset,
          left: 0,
          right: 0,

          overflow: "auto",
        }}
      />

      <Footer />
      {theme ? <NewFooter /> : null}
    </div>
  );
};

export default MMI;
